import React from "react";

export default function ProfitTotals({ profits }) {
  return (
    <tr className="profitBorders">
      <td className="alignLeft">Profit</td>
      <td>{profits.month1}</td>
      <td>{profits.month2}</td>
      <td>{profits.month3}</td>
      <td>{profits.month4}</td>
      <td>{profits.month5}</td>
      <td>{profits.month6}</td>
      <td>{profits.month7}</td>
      <td>{profits.month8}</td>
      <td>{profits.month9}</td>
      <td>{profits.month10}</td>
      <td>{profits.month11}</td>
      <td>{profits.month12}</td>
    </tr>
  );
}
